export const storeTooltipIdToHide = (store) => {
  const eventId = store.getState()?.eviteEvent?.id;
  const tooltipId = localStorage.getItem('tooltip-id-to-hide') || '';
  if (tooltipId && eventId) {
    // Store event and tooltip specific id in existing hidden-tooltips array or a new array
    const tooltipEventId = `${tooltipId}_${eventId}`;
    const hiddenTooltips = JSON.parse(localStorage.getItem('hidden-tooltips') || '[]');
    hiddenTooltips.push(tooltipEventId);
    localStorage.setItem('hidden-tooltips', JSON.stringify(hiddenTooltips));
    // Remove temporary localStorage item
    localStorage.removeItem('tooltip-id-to-hide');
  }
};
